import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Navigate, Outlet, useLocation } from 'react-router';
import { loginPath, useSession } from '../api/auth';

/**
 * Guardia delle rotte della suite (DEC-007): senza sessione porta a `/accesso` ricordando dove si
 * voleva andare; con la sessione rende le rotte figlie. L'API non raggiungibile è un errore
 * esplicito con «Riprova», non un rimando al login.
 */
export function RequireSession() {
  const { data, isPending, isError, error, refetch, isFetching } = useSession();
  const location = useLocation();

  if (isPending) {
    return (
      <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>
        <Stack direction="row" spacing={2} alignItems="center" role="status">
          <CircularProgress size={20} />
          <Typography>Verifica dell'accesso…</Typography>
        </Stack>
      </Box>
    );
  }

  if (isError) {
    return (
      <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', p: 4 }}>
        <Alert
          severity="error"
          action={
            <Button color="inherit" size="small" onClick={() => void refetch()} disabled={isFetching}>
              Riprova
            </Button>
          }
        >
          <AlertTitle>Impossibile verificare l'accesso</AlertTitle>
          {error.message}
        </Alert>
      </Box>
    );
  }

  if (!data) {
    return <Navigate to={loginPath(location.pathname + location.search + location.hash)} replace />;
  }

  return <Outlet />;
}
